/**
 * Resolve the Laravel API origin from the page hostname.
 * console.ocdev2.dev.oddscomposer.io → https://api.v2.test.ocdev2.dev.oddscomposer.io/
 * Falls back to VITE_API_URL when the host is not an ocdev* console.
 */
export function resolveApiBaseUrl() {
  if (import.meta.env.DEV) {
    return ''
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const match = window.location.hostname.match(/\b(ocdev\d+)\.dev\.oddscomposer\.io$/i)
    if (match) {
      return `https://api.v2.test.${match[1].toLowerCase()}.dev.oddscomposer.io/`
    }
  }

  const fromEnv = import.meta.env.VITE_API_URL
  if (fromEnv) {
    return fromEnv.endsWith('/') ? fromEnv : `${fromEnv}/`
  }

  return 'https://api.v2.test.oddscomposer.io/'
}

export function resolveApiOrigin() {
  return resolveApiBaseUrl().replace(/\/$/, '')
}
